import { render, staticRenderFns } from "./SalesWeekly.vue?vue&type=template&id=98d4ddde&scoped=true&"
import script from "./SalesWeekly.vue?vue&type=script&lang=ts&"
export * from "./SalesWeekly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d4ddde",
  null
  
)

export default component.exports